<template>
    <div class="layout-detail-shensha">
        <div class="layout-dss-list dsp-flex" v-bind:class="'layout-dss-list-' + detailShenShaList.length">
            <div class="layout-dss-item" v-for="data in detailShenShaList">
                <p class="dss-item-p-one" v-for="cs in data.changsheng">{{cs}}</p>
                <p class="dss-item-p-two" v-for="ss in data.shensha">{{ss}}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DetailShensha',
    computed: {
       detailShenShaList() {
            return this.$store.state.detail.detailShenShaList;
        }
    },
    methods: {

    }
}
</script>